import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { Badge as ShadcnBadge } from '@/components/ui/badge';

/**
 * COMPATIBILITY SHIM — legacy 6-tone Badge over shadcn's 4 variants.
 *
 * success/warning/info have no shadcn equivalent, so they use `outline` plus
 * the semantic tokens added in index.css. All tones therefore follow dark mode.
 */

type Tone = 'default' | 'navy' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const VARIANT = {
  default: 'secondary',
  navy: 'default',
  danger: 'destructive',
  success: 'outline',
  warning: 'outline',
  info: 'outline',
} as const;

const TONE_CLASS: Record<Tone, string> = {
  default: '',
  navy: '',
  danger: '',
  success: 'border-success/20 bg-success/10 text-success',
  warning: 'border-warning/20 bg-warning/10 text-warning',
  info: 'border-info/20 bg-info/10 text-info',
};

export function Badge({ tone = 'default', children, className, style }: BadgeProps) {
  return (
    <ShadcnBadge
      variant={VARIANT[tone]}
      className={cn(TONE_CLASS[tone], className)}
      style={style}
    >
      {children}
    </ShadcnBadge>
  );
}
